import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog'
import { WIDGET_REGISTRY } from './registry'
import type { WidgetSummary } from '@/redux/service/widgets'

interface WidgetPreviewDialogProps {
  widget: WidgetSummary | null
  onClose: () => void
}

export function WidgetPreviewDialog({
  widget,
  onClose,
}: WidgetPreviewDialogProps) {
  const PreviewComponent = widget
    ? WIDGET_REGISTRY[widget.component_key]?.component
    : undefined

  return (
    <Dialog open={widget !== null} onOpenChange={open => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{widget?.name}</DialogTitle>
          <DialogDescription>{widget?.description}</DialogDescription>
        </DialogHeader>
        <div className='pt-2 h-64'>
          {PreviewComponent ? (
            <PreviewComponent />
          ) : (
            <p className='text-sm text-muted-foreground'>
              No preview available for this widget.
            </p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
